<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Cancel Reservation Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5"
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.cancelReservationPageHeader }}
    </h2>
    <p class="text-h8 font-weight-bold"
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.cancelReservationPageSubHeader }}
    </p>
    <div v-for="booking in existingBookings" :key="booking.BookingId" class="pb-4">
      <v-card>
        <v-card-text class="centerContainer">
          <reservation-details :booking="booking" 
            :showBarcode="false" 
            :footerText="siteText.ui.cancelMessageText"
            :isRTL="isRTLLanguage"
            >
          </reservation-details>
          <div class="text-left">
          <v-layout row wrap
          :class="isRTLLanguage ? 'rtl' : 'normal'">
            <v-flex md3>
              <v-btn
                class="ma-2 dmv-btn"
                height="45px"
                width="260px"
                @click="cancelConfirmation(booking.BookingId)"
              >
                {{ siteText.ui.cancelConfirmation }}
              </v-btn>
            </v-flex>
          </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <p></p>
    <div class="text-left">
      <v-layout row wrap>
      <v-flex md3>
        <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="back()"
          ><v-icon>mdi-arrow-left</v-icon>
          {{ siteText.ui.cancelBack }}
        </v-btn>
      </v-flex>      
      </v-layout>
    </div>
  </div>
</template>

<script>
import ReservationDetails from '@/components/ReservationDetails.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { ReservationDetails },
  name: 'CancelReservationPage',
  methods: {
    ...mapActions(['cancelBooking']),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      if (this.previousPage === 'ViewReservationPage') {
        this.$emit('navigateTo', 'ViewReservationPage', { 
          pageName:'View Reservation Details'
      });
      } else if (this.previousPage === 'DataColllectionPage') {
        this.$emit('navigateTo', 'DataCollectionPage',
        {
            header: this.siteText.ui.cancelReservationHeader,
            subHeader: this.siteText.ui.cancelReservationSubHeader,
            subHeader2: this.siteText.ui.cancelReservationSubHeader2,
            pageName:'Cancel Your Reservation'
        });
      }
    },
    async cancelConfirmation(bookingId) {
      await this.cancelBooking(bookingId);
      this.$emit('navigateTo', 'CancelConfirmationPage', { 
          pageName:'Reservation Canceled'
      });
    },
},
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['previousPage']),
    ...mapGetters(['bookings']),
    ...mapGetters(['selectedBooking', 'isRTLLanguage']),
    existingBookings() {
       let bookings = this.bookings;
       if(this.selectedBooking) {
        bookings = [this.selectedBooking];
       }
       return bookings;
    }
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
